import * as Yup from 'yup';
import { TFunction } from 'i18next';
import { IStartChargeForm } from 'models/driver';
import { Common } from 'utils/constants';

export const StartChargeValidationSchema = (t: TFunction, isSpecialAccount: boolean, isFleetAccount: boolean) => {
    if (isSpecialAccount) {
        return Yup.object().shape({
            location: Yup.mixed().required('required'),
            station: Yup.mixed().required('required'),
            connector: Yup.mixed().required('required'),
            limitedKWH: Yup.boolean(),
            confirmationCheck: Yup.boolean().required('required'),
            first_name: Yup.string()
                .nullable()
                .required('required')
                .trim()
                .matches(Common.RegularExpression.FullNameRegularExpression, t('driver.errors.fullName.valid')),
            phoneNumber: Yup.string()
                .nullable()
                .required('required')
                .matches(Common.RegularExpression.PhoneNumberRegularExpression, t('driver.errors.phoneNo.match')),
            email: Yup.string()
                .nullable()
                .matches(Common.RegularExpression.EmailRegularExpression, t('driver.errors.email.email'))
                .required('required'),
            rfidCard: Yup.mixed().nullable(),
            vehicle_number: Yup.string().nullable(),
        }) as unknown as Yup.SchemaOf<IStartChargeForm>;
    }
    return Yup.object().shape({
        location: Yup.mixed().required('required'),
        station: Yup.mixed().required('required'),
        connector: Yup.mixed().required('required'),
        limitedKWH: Yup.boolean(),
        confirmationCheck: Yup.boolean().required('required'),
        first_name: Yup.string().nullable(),
        phoneNumber: Yup.string().nullable(),
        email: Yup.string().nullable(),
        rfidCard: isFleetAccount ? Yup.mixed().required('required') : Yup.mixed().nullable(),
        vehicle_number: Yup.string().nullable(),
    }) as unknown as Yup.SchemaOf<IStartChargeForm>;
};
